module.exports = __webpack_public_path__ + "img/pro1.e73b7bcb.png";